'use strict';

/**
 * @type {import("gatsby").GatsbyBrowser['shouldUpdateScroll']}
 */
exports.shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  const prev = prevRouterProps && prevRouterProps.location && prevRouterProps.location.state;
  const next = routerProps && routerProps.location && routerProps.location.state;

  if (!prev || !next) {
    return;
  }

  // Не нужно скроллить наверх, если это взаимодействие с лайтбоксом
  if (prev.lightbox !== next.lightbox) {
    return false;
  }
};
